module.exports = __webpack_public_path__ + "media/images/lesson_9/sebastiao_urso-dafa0c2278a7fb1761191f6cfb5ffae6.png";